export default __webpack_public_path__ + "static/media/trampapo_01-08.8a692f7b.png";